export default {
    apply: 'Ok',
    cancel: 'Clear',
    from: 'From',
    to: 'To',
    customRangeLabel: 'Range',
    ranges: {
        last_7_days: 'Last 7 Days',
        last_30_days: 'Last 30 Days',
        current_month: 'Current Month',
        last_month: 'Last Month',
        current_year: 'Current Year',
        last_year: 'Last Year',
    },
}
